var React = require('react');

function Military (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"fill":"none","x":"0","y":"0","width":"21","height":"21","key":0}),React.createElement("path",{"fill":"#ffffff","transform":"translate(3 3)","d":"M5.5,1L6,2h5l0.5-1H5.5z M6,2.5v1.25c0,0,0,2.75,2.5,2.75S11,3.75,11,3.75V2.5H6z M1.9844,3.9863 C1.4329,3.9949,0.9924,4.4485,1,5v4c-0.0001,0.6398,0.5922,1.1152,1.2168,0.9766L5,9.3574V14l5.8789-6.9297 C10.7391,7.0294,10.5947,7,10.4414,7H6.5L3,7.7539V5C3.0077,4.4362,2.5481,3.9775,1.9844,3.9863z M11.748,7.7109L6.4121,14H12 V8.5586C12,8.2451,11.9061,7.9548,11.748,7.7109z","style":{"strokeLinejoin":"round","strokeMiterlimit":"4"},"stroke":"#ffffff","strokeWidth":"2","key":1}),React.createElement("path",{"fill":"#ff4081","transform":"translate(3 3)","d":"M5.5,1L6,2h5l0.5-1H5.5z M6,2.5v1.25c0,0,0,2.75,2.5,2.75S11,3.75,11,3.75V2.5H6z M1.9844,3.9863 C1.4329,3.9949,0.9924,4.4485,1,5v4c-0.0001,0.6398,0.5922,1.1152,1.2168,0.9766L5,9.3574V14l5.8789-6.9297 C10.7391,7.0294,10.5947,7,10.4414,7H6.5L3,7.7539V5C3.0077,4.4362,2.5481,3.9775,1.9844,3.9863z M11.748,7.7109L6.4121,14H12 V8.5586C12,8.2451,11.9061,7.9548,11.748,7.7109z","key":2})]);
}

Military.defaultProps = {"viewBox":"0 0 21 21"};

module.exports = Military;

Military.default = Military;



//////////////////
// WEBPACK FOOTER
// ../assets/icons/military.svg
// module id = 913
// module chunks = 9